import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function capitalizeFirstLetterOfEachWord(str: string) {
  return str
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export function capitalizeFirstChar(str: string) {
  if (!str) return str;
  return str.charAt(0).toUpperCase() + str.slice(1);
}

// Generate consistent color for each subject based on subject ID
export function getSubjectColor(subjectId: number) {
  const colors = [
    'text-blue-600 bg-blue-50',
    'text-green-600 bg-green-50',
    'text-purple-600 bg-purple-50',
    'text-red-600 bg-red-50',
    'text-yellow-600 bg-yellow-50',
    'text-indigo-600 bg-indigo-50',
    'text-pink-600 bg-pink-50',
    'text-teal-600 bg-teal-50',
    'text-orange-600 bg-orange-50',
    'text-cyan-600 bg-cyan-50',
  ];
  return colors[subjectId % colors.length];
}

// Payment Method Colors Utility
export const getPaymentMethodColors = (paymentType: string) => {
  const normalizedType = paymentType?.toUpperCase();

  switch (normalizedType) {
    case 'CASH':
      return {
        bg: 'bg-green-100',
        text: 'text-green-700',
        border: 'border-green-200',
        hover: 'hover:bg-green-100',
        className: 'bg-green-100 text-green-700 border-green-200 hover:bg-green-100',
      };
    case 'UPI':
      return {
        bg: 'bg-blue-100',
        text: 'text-blue-700',
        border: 'border-blue-200',
        hover: 'hover:bg-blue-100',
        className: 'bg-blue-100 text-blue-700 border-blue-200 hover:bg-blue-100',
      };
    case 'CHEQUE':
      return {
        bg: 'bg-purple-100',
        text: 'text-purple-700',
        border: 'border-purple-200',
        hover: 'hover:bg-purple-100',
        className: 'bg-purple-100 text-purple-700 border-purple-200 hover:bg-purple-100',
      };
    case 'BANK_TRANSFER':
    case 'BANK TRANSFER':
    case 'ONLINE':
      return {
        bg: 'bg-orange-100',
        text: 'text-orange-700',
        border: 'border-orange-200',
        hover: 'hover:bg-orange-100',
        className: 'bg-orange-100 text-orange-700 border-orange-200 hover:bg-orange-100',
      };
    default:
      return {
        bg: 'bg-gray-100',
        text: 'text-gray-700',
        border: 'border-gray-200',
        hover: 'hover:bg-gray-100',
        className: 'bg-gray-100 text-gray-700 border-gray-200 hover:bg-gray-100',
      };
  }
};
